import { MapAction, MapActions, NO_CONFIGURATION } from './actions';
import { MapCategory, MapConfiguration, PortAndWaterwayObject } from '../../../types';
import { COORD_PATTERN, SortDirection } from '../../../utils';

export interface MapState {
  objects: PortAndWaterwayObject[];
  loadingObjects: boolean;
  categories: MapCategory[];
  loadingCategories: boolean;
  configuration: MapConfiguration;
  loadingConfiguration: boolean;
  selectedCategories: string[];
  filterText: string;
  sortGeo: SortDirection;
}

function toggleCategory(selectedCategories: string[], category: MapCategory): string[] {
  const cats = selectedCategories || [];
  if (cats.includes(category.type)) {
    return [...cats].filter((c) => c !== category.type);
  }
  return [...cats, category.type];
}

function cycleSort(sortDirection: SortDirection) {
  switch (sortDirection) {
    case SortDirection.ASCENDING:
      return SortDirection.DESCENDING;
    case SortDirection.DESCENDING:
      return SortDirection.NONE;
    case SortDirection.NONE:
      return SortDirection.ASCENDING;
    default:
      return SortDirection.ASCENDING;
  }
}

const MAP_SELECTED_CATEGORIES_KEY = 'MAP_SELECTED_CATEGORIES';

const initialSelectedCategories: string[] = (function (): string[] {
  const stored = localStorage.getItem(MAP_SELECTED_CATEGORIES_KEY);
  const cat: string[] = (stored && JSON.parse(stored)) || undefined;
  if (!cat || !Array.isArray(cat)) {
    localStorage.removeItem(MAP_SELECTED_CATEGORIES_KEY);
    return undefined;
  }
  return cat.filter((item) => typeof item === 'string');
})();

export default function pinReducer(
  state: MapState = {
    objects: [],
    loadingObjects: false,
    categories: [],
    loadingCategories: false,
    configuration: NO_CONFIGURATION,
    loadingConfiguration: false,
    selectedCategories: initialSelectedCategories,
    filterText: '',
    sortGeo: SortDirection.ASCENDING,
  },
  action: MapActions
): MapState {
  switch (action.type) {
    case MapAction.LOAD_OBJECTS:
      return {
        ...state,
        objects: action.objects.filter((o) => COORD_PATTERN.test(`${o.latitude},${o.longitude}`)),
      };
    case MapAction.LOAD_CATEGORIES:
      return { ...state, categories: action.categories };
    case MapAction.LOADING_CATEGORIES:
      return { ...state, loadingCategories: action.loadingCategories };
    case MapAction.LOAD_CONFIGURATION:
      return { ...state, configuration: action.configuration };
    case MapAction.LOADING_CONFIGURATION:
      return { ...state, loadingConfiguration: action.loadingConfiguration };
    case MapAction.LOADING_OBJECTS:
      return { ...state, loadingObjects: action.loadingObjects };
    case MapAction.TOGGLE_CATEGORY:
      const selectedCategories = toggleCategory(state.selectedCategories, action.category);
      localStorage.setItem(MAP_SELECTED_CATEGORIES_KEY, JSON.stringify([...selectedCategories]));
      return { ...state, selectedCategories };
    case MapAction.UPDATE_FILTER_TEXT:
      return { ...state, filterText: action.text };
    case MapAction.SORT_GEO:
      return { ...state, sortGeo: cycleSort(state.sortGeo) };
    default:
      return state;
  }
}
